<ng-container *ngIf="isLoaded; else loading">
    <div [class.small]="small" [hidden]="hideTypeChoosing" class="flex-row">
        <mat-button-toggle-group #group="matButtonToggleGroup" (change)="onToggleGroupChange($event)"
                                 [(ngModel)]="commentType" class="customToggleGroup flex-wrap flex-row">
            <mat-button-toggle (click)="reset()"
                               *ngIf="attachmentOptions.includes('text') && group.value != 'text' &&  group.value"
                               value="text">
                <mat-icon>close</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('image')" value="image"
                               [matTooltip]="isMobileSize? 'Image':''">
                <mat-icon>image</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Image</ng-container>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('video')" value="video"
                               [matTooltip]="isMobileSize? 'Video':''">
                <mat-icon>videocam</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Video</ng-container>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('audio')" value="audio"
                               [matTooltip]="isMobileSize? 'Audio':''">
                <mat-icon>audiotrack</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Audio</ng-container>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('videoLink')" value="videoLink"
                               [matTooltip]="isMobileSize? 'External Embed':''">
                <mat-icon>link</mat-icon>
                <ng-container *ngIf="!isMobileSize"> External Embed</ng-container>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('screenRecording')" value="screenRecording"
                               [matTooltip]="isMobileSize? 'Screen Recording':''">
                <mat-icon>screen_share</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Screen Recording</ng-container>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('gif')" value="gif"
                               [matTooltip]="isMobileSize? 'GIF':''">
                <mat-icon>gif</mat-icon>
                <ng-container *ngIf="!isMobileSize"> GIF</ng-container>
            </mat-button-toggle>
            <mat-button-toggle
                    *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !reply && attachmentOptions.includes('heatmap')"
                    value="heatmap" [matTooltip]="isMobileSize? 'Heatmap':''">
                <mat-icon>scatter_plot</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Heatmap</ng-container>
            </mat-button-toggle>
            <mat-button-toggle
                    *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !reply && attachmentOptions.includes('survey_url')"
                    value="survey_url" [matTooltip]="isMobileSize? 'Survey':''">
                <mat-icon>assignment</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Survey</ng-container>
            </mat-button-toggle>
            <mat-button-toggle
                    *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !reply && attachmentOptions.includes('poll')"
                    value="poll" [matTooltip]="isMobileSize? 'Poll':''">
                <mat-icon>poll</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Poll</ng-container>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('doc')" value="doc"
                               [matTooltip]="isMobileSize? 'Doc':''">
                <mat-icon>attach_file</mat-icon>
                <ng-container *ngIf="!isMobileSize"> Doc</ng-container>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="attachmentOptions.includes('url')" value="url"
                               [matTooltip]="isMobileSize? 'URL':''">
                <mat-icon>link</mat-icon>
                <ng-container *ngIf="!isMobileSize"> URL</ng-container>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <ng-container *ngIf="group.value == 'image'">
        <div *ngIf="!disable" class="w-100 text-center">
            <ng-container *ngTemplateOutlet="fileSizeError"></ng-container>
        </div>
        <div class="flex-col align-items-center">
            <div *ngIf="!disable" class="w-100">
                <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField"
                                color="primary">
                    <mat-label *ngIf="!isApp">Click or drop an image here to upload</mat-label>
                    <mat-label *ngIf="isApp">Click to add an image here to upload</mat-label>
                    <ngx-mat-dropzone>
                        <input #imageInput [formControl]="imageCtrl" [multiple]="false"
                               accept=".jpg, .jpeg, .png, .bmp, .svg, .webp" fileInput mode="replace" type="file"/>
                    </ngx-mat-dropzone>
                    <mat-hint class="ml-N1">Allowed formats: JPG, JPEG, PNG, BMP, SVG, WEBP</mat-hint>
                </mat-form-field>
                <mat-checkbox (change)="this.imagePositionChange.emit($event.checked)" [checked]="displayOverText">
                    Display attachments above text
                </mat-checkbox>
            </div>
            <div *ngIf="image" class="mediaControl">
                <img [src]="image">
            </div>
        </div>

    </ng-container>
    <ng-container *ngIf="group.value == 'video'">
        <div class="w-100 text-center">
            <ng-container *ngTemplateOutlet="fileSizeError"></ng-container>
        </div>
        <div class="flex-col">
            <div class="w-100">
                <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField"
                                color="primary">
                    <mat-label *ngIf="!isApp">Click or drop a video here to upload</mat-label>
                    <mat-label *ngIf="isApp">Click to add a video here to upload</mat-label>
                    <ngx-mat-dropzone>
                        <input #videoInput [formControl]="videoCtrl" [multiple]="false" accept=".mp4, .mov" fileInput
                               mode="replace" type="file"/>
                    </ngx-mat-dropzone>
                    <mat-hint class="ml-N1">Allowed formats: MP4, MOV</mat-hint>
                </mat-form-field>
            </div>
            <div *ngIf="video" class="mediaControl">
                <video controls>
                    <source [src]="video" [type]="'video/mp4'">
                </video>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="group.value == 'audio'">
        <div class="w-100 text-center">
            <ng-container *ngTemplateOutlet="fileSizeError"></ng-container>
        </div>
        <div class="flex-col">
            <div class="w-100">
                <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField"
                                color="primary">
                    <mat-label *ngIf="!isApp">Click or drop a audio here to upload</mat-label>
                    <mat-label *ngIf="isApp">Click to add a audio here to upload</mat-label>
                    <ngx-mat-dropzone>
                        <input #audioInput [formControl]="audioCtrl" [multiple]="false"
                               accept="audio/mpeg, audio/wav" fileInput
                               mode="replace" type="file"/>
                    </ngx-mat-dropzone>
                    <mat-hint class="ml-N1">Allowed formats: MPEG, WAV</mat-hint>
                </mat-form-field>
            </div>
            <div *ngIf="audio" class="mediaControl">
                <app-audio-player [file]="this.audio"></app-audio-player>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="group.value == 'screenRecording'">
        <div class="w-100 text-center">
            <small *ngIf="this.fileSize < this.maxScreenRecordingFilesize">Upload file size is limited
                to {{ this.maxScreenRecordingFilesize }}mb</small>
            <small *ngIf="this.fileSize >= this.maxScreenRecordingFilesize" class="errorMsg">Upload file size is limited
                to {{ this.maxScreenRecordingFilesize }}mb for screen recordings your file
                is {{ this.fileSize }}MB</small>
        </div>
        <ng-container *ngIf="isMobile">
            <p>Unfortunately screen recording is not supported on your device/browser.
                Please use the guide below to record your screen using your devices native recording feature then upload
                the file as a video attachment.</p>
            <a target="_blank" referrerpolicy="no-referrer"
               [href]="isMobile == 'ANDROID'? 'https://support.google.com/android/answer/9075928?hl=en-GB':'https://support.apple.com/en-gb/102653'"
               mat-raised-button color="accent">Guide to creating a screen recording </a>
        </ng-container>
        <div class="flex-col gap-15 mt-20 align-items-center" *ngIf="!isMobile">
            <button (click)="startScreenRecording()" *ngIf="!this.recording" class="w-content" color="accent"
                    mat-raised-button>
                Record screen
            </button>
            <button (click)="startScreenRecording(true)" *ngIf="!this.recording" class="w-content" color="accent"
                    mat-raised-button>
                Record screen and microphone audio
            </button>
            <button (click)="stopScreenRecording()" *ngIf="this.recording" class="w-content" color="warn"
                    mat-raised-button>
                <mat-icon class="live">fiber_manual_record</mat-icon>
                Stop Recording
            </button>
        </div>
        <div class="d-flex align-items-center flex-col pt-10" *ngIf="screenRecordingUrl">
            <a download="recording.mkv" [href]="screenRecordingUrl" class="w-content" color="accent"
               mat-raised-button>
                <mat-icon>cloud_download</mat-icon>
                Download Recording
            </a>
            <div *ngIf="screenRecordingUrl" class="mediaControl">
                <video [src]="this.screenRecordingUrl" controls></video>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="group.value == 'videoLink'">
        <mat-form-field appearance="outline" class="w-100 whiteField mb-20">
            <mat-label>External Embed</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(videoLinkFormControl, 'videoLink')" [formControl]="videoLinkFormControl"
                   matInput>
            <mat-error *ngIf="videoLinkFormControl.hasError('pattern')">
                Please enter a valid url e.g. https://www.youtube.com/watch?v=dQw4w9WgXcQ
            </mat-error>
            <mat-hint>Use full URL e.g. https://www.youtube.com/watch?v=dQw4w9WgXcQ</mat-hint>
            <button (click)="videoLinkUpload(videoLinkFormControl.value)" [disabled]="videoLinkFormControl.invalid"
                    mat-icon-button
                    matSuffix matTooltip="Verify link">
                <mat-icon>find_in_page</mat-icon>
            </button>
        </mat-form-field>

        <div *ngIf="videoLink && videoLink.type !== 'vimeo'" class="mediaControl">
            <iframe *ngIf="videoLink.link" [src]="videoLink.link"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                    appHideGiphyOverlay
                    class="youtubeEmbed mt-10 px-16"
                    frameborder="0"
                    height="auto" referrerpolicy="strict-origin-when-cross-origin"></iframe>
        </div>

        <div *ngIf="videoLink && videoLink.type == 'vimeo'" class="mediaControl vimeo">
            <iframe *ngIf="videoLink.link" [src]="videoLink.link" allow="autoplay" frameborder="0"></iframe>
        </div>

    </ng-container>
    <ng-container *ngIf="group.value == 'link'">
        <mat-form-field appearance="outline" class="w-100 whiteField">
            <mat-label>Link</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(linkFormControl, 'link')" [formControl]="linkFormControl" matInput>
            <mat-error *ngIf="linkFormControl.hasError('pattern')">
                Please enter a valid url e.g. https://www.example.com/
            </mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngIf="group.value == 'doc'">
        <div class="w-100 text-center">
            <ng-container *ngTemplateOutlet="fileSizeError"></ng-container>
        </div>
        <div class="docRow">
            <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField" color="primary">
                <mat-label *ngIf="!doc">Click or drop a file here to upload</mat-label>
                <mat-label *ngIf="doc">{{ doc }} uploaded click or drop a file here to replace</mat-label>
                <ngx-mat-dropzone>
                    <input [formControl]="docCtrl" [multiple]="false" accept=".pdf, .docx, .xlsx, .txt, .csv" fileInput
                           mode="replace" type="file"/>
                </ngx-mat-dropzone>
                <mat-hint class="ml-N1">Allowed formats: PDF, DOCX, XLSX, TXT, CSV</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100 whiteField" color="accent">
                <mat-label>Document Title</mat-label>
                <input [formControl]="docTitle" matInput type="text" maxlength="99"/>
            </mat-form-field>
        </div>
    </ng-container>
    <ng-container *ngIf="group.value == 'gif'">

        <mat-form-field appearance="outline" class="w-100 whiteField" color="accent">
            <mat-label>Search</mat-label>
            <input #search (keyup.enter)="searchGifs(search.value)" matInput>
            <button (click)="searchGifs(search.value)" [disabled]="!search.value" aria-label="Search Gifs"
                    mat-icon-button matPrefix matTooltip="Search gifs">
                <mat-icon color="accent">
                    search
                </mat-icon>
            </button>
            <mat-hint>
                <img alt="" class="accreditation" src="assets/giphy.png">
            </mat-hint>
        </mat-form-field>
        <div class="flex-row flex-wrap gifHolder">
            <img (click)="selectGif(resultGif)" *ngFor="let resultGif of gifs" [alt]="resultGif.alt_text"
                 [class.selectedGif]="resultGif== this.gif"
                 [src]="resultGif.images.fixed_height_downsampled.url" class="gif">
            <iframe *ngIf="initialFile?.embed_url && !gifs?.length" [src]="safeImageLink"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    appHideGiphyOverlay
                    frameborder="0"
                    referrerpolicy="strict-origin-when-cross-origin"></iframe>
        </div>
        <mat-paginator (page)="handlePageEvent($event, search.value)" *ngIf="gifs.length>0"
                       [length]="resultsLength"
                       [pageSize]="this.limit"
                       aria-label="Select page">
        </mat-paginator>

    </ng-container>

    <ng-container *ngIf="group.value == 'survey_url'">
        <mat-form-field appearance="outline" class="w-100 whiteField">
            <mat-label>Survey</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(surveyFormControl, 'survey_url')" [formControl]="surveyFormControl" matInput>
            <mat-error *ngIf="surveyFormControl.hasError('pattern')">
                Please enter a valid survey url e.g. https://www.example.com/
            </mat-error>
            <mat-hint>The users id will be attached to the link: [LINK]?id=[USER ID]</mat-hint>
        </mat-form-field>
    </ng-container>

    <ng-container *ngIf="group.value == 'url'">
        <mat-form-field appearance="outline" class="w-100 whiteField">
            <mat-label>URL</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(surveyFormControl, 'url')" [formControl]="surveyFormControl" matInput>
            <mat-error *ngIf="surveyFormControl.hasError('pattern')">
                Please enter a valid url url e.g. https://www.example.com/
            </mat-error>
        </mat-form-field>
    </ng-container>

    <ng-container *ngIf="group.value == 'poll'">
        <div *ngIf="!initialPoll" class="mt-10 mb-10 d-flex align-items-center gap-10">
            <h3>Poll: </h3>
        </div>
        <app-create-poll (isValidPollData)="isValid.emit($event)"
                         (pollData)="!isEditPoll && submitField.emit({ value: $event, type: 'poll' })"
                         (pollUpdateCanceled)="isEditPoll = false"
                         (pollUpdated)="pollUpdated($event)"
                         *ngIf="!initialPoll || isEditPoll"
                         [initialPollData]="initialPoll"/>

        <div *ngIf="initialPoll && !isEditPoll" class="mt-15 relative">
            <app-poll-view [pollData]="initialPoll" [preview]="true"></app-poll-view>
            <div class="action-buttons-container">
                <button (click)="$event.stopPropagation(); editPoll()" aria-label="Edit Poll" class="delete-icon-button"
                        color="accent"
                        mat-icon-button matTooltip="Edit Poll">
                    <mat-icon>edit</mat-icon>
                </button>
                <button (click)="$event.stopPropagation(); removePoll()" aria-label="Delete Poll"
                        class="delete-icon-button" color="accent"
                        mat-icon-button matTooltip="Delete Poll">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="group?.value == 'heatmap'">
        <app-create-heatmap
                (isValidPollData)="isValid.emit($event)"
                (pollData)="submitField.emit({ value: $event, type: 'heatmap' })"
                *ngIf="!initialHeatmap || heatMapEditMode"
                [initialPollData]="initialHeatmap"/>

        <div *ngIf="initialHeatmap" class="max-w-600 relative">
            <app-heatmap-vote *ngIf="!heatMapEditMode" [heatmap]="initialHeatmap" [preview]="true"/>
            <div *ngIf="!heatMapEditMode" class="flex-row gap-5">
                <div class="flex-row gap-2 ml-20 align-items-center">
                    <span *ngIf="initialHeatmap.end_at"
                          style="color: var(--accent)">* The poll will close {{ initialHeatmap.end_at | relativeTime }}</span>
                    <button (click)="$event.stopPropagation(); changeHeatmapEndDate()"
                            aria-label="Change Heatmap end date" class="delete-icon-button"
                            color="accent"
                            mat-icon-button
                            matTooltip="Change Heatmap end date">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
                <button (click)="$event.stopPropagation(); removeHeatmap()" aria-label="Delete Heatmap"
                        class="delete-icon-button" color="accent"
                        mat-icon-button matTooltip="Delete Heatmap">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>

    </ng-container>
</ng-container>

<ng-template #loading>
    <div class="d-flex flex-center align-items-center loader-container">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>

<ng-template #fileSizeError>
    <small *ngIf="this.fileSize < this.maxFilesize">Upload file size is limited to {{ this.maxFilesize }}mb</small>
    <small *ngIf="this.fileSize >= this.maxFilesize" class="errorMsg">Upload file size is limited
        to {{ this.maxFilesize }}mb your file
        is {{ this.fileSize }}MB</small>
</ng-template>
